module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/exit-2ae723e88ce904a68e52ad5d09db3083.svg";